/* ============================================================================
   BOOST CUSTOMISATION 2026-06-24 (updated 2026-07-02)
   "View more menu items" overflow-dropdown controller
   ----------------------------------------------------------------------------
   2026-07-02: panel now opens down-and-to-the-right of the pill and flips to
   right-aligned if it would run past the viewport edge (positionPanel).
   ----------------------------------------------------------------------------
   Purpose
     The Xtra horizontal mega-menu hides top-level items that do not fit the nav
     width and reveals a small "View more menu items" control (li.show-all) at the
     right end of the bar. Off the shelf, that control was an <a class="toggle">
     pointing at the home page as a no-JS fallback; the theme's own toggle
     handlers were not reliably intercepting the click, so clicking it navigated
     home instead of expanding the hidden items.

   What this does
     - Fully owns the click / tap / keyboard behaviour of the show-all control
       (marked in header-menu.liquid with class "boost-show-more-toggle").
     - Opens / closes the cloned overflow list (.show-all-submenu, still built by
       custom.js) by toggling the class "boost-show-more-open" on the parent
       li.show-all. Styling lives in boost-menu-show-more.css.
     - Closes on outside click, ESC (returns focus to the control), and on resize.
     - Works for every show-all control on the page (the in-header #nav-bar and
       the #nav bar), and closes any other open one when a new one is opened.

   Dependencies: none (vanilla JS). Self-contained.
   ========================================================================== */
(function () {
  'use strict';

  var TOGGLE_SEL = '.boost-show-more-toggle';
  var LI_SEL = 'li.show-all';
  var OPEN_CLASS = 'boost-show-more-open';
  var FLIP_CLASS = 'boost-show-more-flip';
  var PANEL_SEL = '.show-all-submenu';

  function openLis() {
    return document.querySelectorAll(LI_SEL + '.' + OPEN_CLASS);
  }

  function closeAll(except) {
    var lis = openLis();
    for (var i = 0; i < lis.length; i++) {
      if (except && lis[i] === except) continue;
      lis[i].classList.remove(OPEN_CLASS);
      lis[i].classList.remove(FLIP_CLASS);
      var t = lis[i].querySelector(TOGGLE_SEL);
      if (t) t.setAttribute('aria-expanded', 'false');
    }
  }

  /* The panel opens down-and-to-the-right of the pill by default. If that would
     run past the right edge of the viewport, flip it to right-aligned so it stays
     fully on-screen. Measured after paint so the panel has its real width. */
  function positionPanel(li) {
    li.classList.remove(FLIP_CLASS);
    var panel = li.querySelector(PANEL_SEL);
    if (!panel) return;
    (window.requestAnimationFrame || function (f) { f(); })(function () {
      if (!li.classList.contains(OPEN_CLASS)) return;
      var rect = panel.getBoundingClientRect();
      var vw = document.documentElement.clientWidth || window.innerWidth;
      if (rect.right > vw - 4) {
        li.classList.add(FLIP_CLASS);
      }
    });
  }

  function openLi(li) {
    closeAll(li);
    li.classList.add(OPEN_CLASS);
    var t = li.querySelector(TOGGLE_SEL);
    if (t) t.setAttribute('aria-expanded', 'true');
    positionPanel(li);
  }

  function toggleLi(li) {
    if (li.classList.contains(OPEN_CLASS)) {
      closeAll();
    } else {
      openLi(li);
    }
  }

  /* Capture-phase click handler.
     - On the toggle: prevent default (never follow the inert "#" href) and
       toggle the dropdown. Running in capture means we act before any other
       handler and the inert href can never cause navigation.
     - Click inside an open dropdown: leave it alone so real links navigate.
     - Click anywhere else: close any open dropdown. */
  document.addEventListener(
    'click',
    function (e) {
      var toggle = e.target.closest ? e.target.closest(TOGGLE_SEL) : null;
      if (toggle) {
        e.preventDefault();
        var li = toggle.closest(LI_SEL);
        if (li) toggleLi(li);
        return;
      }
      if (!(e.target.closest && e.target.closest(LI_SEL + '.' + OPEN_CLASS))) {
        closeAll();
      }
    },
    true
  );

  /* Keyboard:
     - ESC closes and returns focus to the toggle.
     - Space activates the control (anchors do not fire click on Space natively)
       and is prevented from scrolling the page. Enter triggers a native click,
       which the handler above already covers. */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      var open = document.querySelector(LI_SEL + '.' + OPEN_CLASS);
      if (open) {
        closeAll();
        var t = open.querySelector(TOGGLE_SEL);
        if (t && typeof t.focus === 'function') t.focus();
      }
      return;
    }
    if (e.key === ' ' || e.key === 'Spacebar') {
      var toggle = e.target.closest ? e.target.closest(TOGGLE_SEL) : null;
      if (toggle) {
        e.preventDefault();
        var li = toggle.closest(LI_SEL);
        if (li) toggleLi(li);
      }
    }
  });

  /* Close on resize: the show-all control is only present while items overflow,
     and the layout recomputes on resize. Closing avoids an orphaned open panel. */
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(closeAll, 150);
  });
})();

/* ============================================================================
   BOOST CUSTOMISATION 2026-07-11
   Deterministic mega-menu overflow controller (Option B)
   ----------------------------------------------------------------------------
   Why this exists
     The Xtra horizontal mega-menu decides which top-level items overflow the nav
     using a heuristic in custom.js (countNavDist: off + width + width +
     margin*tolerance + buffer, versus the nav width). Near the threshold width,
     notably iPad landscape, that estimate is unreliable: trailing items (e.g.
     Industries, Help) get clipped off the bar WITHOUT the .temp-hidden class, so
     the pure-CSS pill reveal (screen.css: #nav-bar > ul > li.temp-hidden ~
     li.show-all -> visible) never fires and the "..." never appears.

   What this does
     Replaces the estimate with a real measurement. With every top-level item laid
     out at natural width it records each item's edge, then keeps the largest
     leading run whose right edge (plus the pill's width and a small buffer) fits
     the available row, and marks the rest as overflow. It writes .temp-hidden to
     BOTH the real <li> and its clone inside .show-all-submenu (matched by
     data-copy), exactly as the theme expects, so the theme then:
       - hides the overflowed real items       (screen.css .temp-hidden:not(.show-all)),
       - reveals the "..." pill                 (screen.css temp-hidden ~ li.show-all),
       - lists exactly the overflowed clones    (async-menu.css .show-all > ul >
                                                 li:not(.temp-hidden){display:none}).
     No theme reveal/hide CSS is changed; this only writes the class the theme
     already reacts to. The click / keyboard / positioning of the panel is still
     owned by the controller above.

   Scope and safety
     - Desktop only: runs at (min-width: 1001px), so the mobile drawer (<=1000px)
       is never touched (that handoff is the theme's existing boundary).
     - Only processes a laid-out nav that owns a li.show-all (the hidden #nav on
       desktop is skipped), and never fewer than one visible item.
     - Runs after custom.js (load order in theme.liquid is custom.js then this
       file, both deferred) and re-applies on a post-settle timer longer than the
       vendor's 100ms resize throttle, so this deterministic result is the last
       writer over .temp-hidden and wins over the estimate.
     - LTR only (the store is en-AU); if the document is RTL it no-ops rather than
       risk mis-hiding.
     - Observes the bar (stable width), not the item row, so hiding items cannot
       feed back into a resize loop.

   Dependencies: none (vanilla JS). Self-contained.
   ========================================================================== */
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 1001px)');
  var BUFFER = 8; // px of breathing room reserved before the pill
  var PILL_FALLBACK = 48; // px, used only if the pill cannot be measured
  var SETTLE_MS = 160; // > custom.js resize throttle (100ms), so we write last

  function isRTL() {
    var de = document.documentElement;
    if (de && de.getAttribute('dir') === 'rtl') return true;
    return !!(document.body && document.body.getAttribute('dir') === 'rtl');
  }

  /* Every horizontal nav that carries an overflow pill (#nav-bar in the header,
     and #nav where present). Each entry keeps the bar, its item row, and pill. */
  function navList() {
    var out = [];
    var bars = document.querySelectorAll('#nav-bar, #nav');
    for (var i = 0; i < bars.length; i++) {
      var ul = bars[i].querySelector('ul[data-type]');
      if (!ul) continue;
      var pill = ul.querySelector(':scope > li.show-all');
      if (pill) out.push({ bar: bars[i], ul: ul, pill: pill });
    }
    return out;
  }

  /* Direct-child top-level items, excluding the pill itself. */
  function topItems(ul) {
    var items = [];
    var kids = ul.children;
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (el.nodeType === 1 && !el.classList.contains('show-all')) items.push(el);
    }
    return items;
  }

  /* Mark/unmark a real item AND its panel clone (matched by data-copy) so the
     bar, the pill reveal and the panel contents all stay in agreement. */
  function setHidden(realLi, pill, hidden) {
    realLi.classList.toggle('temp-hidden', hidden);
    var dc = realLi.getAttribute('data-copy');
    if (dc == null) return;
    var clone = pill.querySelector('.show-all-submenu > li[data-copy="' + dc + '"]');
    if (clone) clone.classList.toggle('temp-hidden', hidden);
  }

  function recomputeOne(entry) {
    var bar = entry.bar, ul = entry.ul, pill = entry.pill;

    // Skip a nav that is not laid out (e.g. the hidden #nav on desktop).
    if (!ul.offsetParent && ul.clientWidth === 0) return;

    var items = topItems(ul);
    if (!items.length) return;

    // 1) Reset to all-visible so we read natural, un-clipped geometry.
    for (var i = 0; i < items.length; i++) setHidden(items[i], pill, false);

    // 2) Available content width of the bar, and its left content edge.
    var barRect = bar.getBoundingClientRect();
    var cs = getComputedStyle(bar);
    var pl = parseFloat(cs.paddingLeft) || 0;
    var pr = parseFloat(cs.paddingRight) || 0;
    var bdl = parseFloat(cs.borderLeftWidth) || 0;
    var contentLeft = barRect.left + bdl + pl;
    var contentWidth = bar.clientWidth - pl - pr;
    if (contentWidth <= 0) return;

    var firstTop = items[0].getBoundingClientRect().top;
    function rightOf(el) { return el.getBoundingClientRect().right - contentLeft; }
    function sameLine(el) { return Math.abs(el.getBoundingClientRect().top - firstTop) < 4; }

    // 3) Everything fits on one line without the pill -> leave all visible.
    var last = items[items.length - 1];
    if (sameLine(last) && rightOf(last) <= contentWidth + 0.5) return;

    // 4) Overflow: reserve the pill and keep the largest fitting leading run.
    //    Leading items never shift when trailing ones are hidden, so the
    //    all-visible geometry read above stays valid for the prefix.
    var pillW = pill.getBoundingClientRect().width || PILL_FALLBACK;
    var limit = contentWidth - pillW - BUFFER;

    var lastVisible = 0; // always keep at least the first item on the bar
    for (var j = 0; j < items.length; j++) {
      if (sameLine(items[j]) && rightOf(items[j]) <= limit) lastVisible = j;
      else break;
    }

    for (var k = 0; k < items.length; k++) setHidden(items[k], pill, k > lastVisible);
  }

  function recompute() {
    if (isRTL()) return;
    if (!DESKTOP.matches) return; // the mobile drawer owns <= 1000px
    var navs = navList();
    for (var i = 0; i < navs.length; i++) recomputeOne(navs[i]);
  }

  /* Apply after paint, and again after the vendor's throttled pass settles, so
     the deterministic result is the final write over .temp-hidden. */
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
  var settleTimer = null;
  function schedule() {
    raf(recompute);
    if (settleTimer) clearTimeout(settleTimer);
    settleTimer = setTimeout(recompute, SETTLE_MS);
  }

  // Initial run (DOM is ready: this script is deferred and loads after custom.js).
  schedule();
  window.addEventListener('load', schedule); // catch the post-logo-load vendor pass
  window.addEventListener('resize', schedule);
  if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', schedule);
  else if (DESKTOP.addListener) DESKTOP.addListener(schedule); // older Safari

  // Recompute when the bar itself changes size (viewport, font load, zoom).
  // Observing the bar (not the item row) avoids a hide -> resize -> hide loop.
  if (typeof ResizeObserver === 'function') {
    var ro = new ResizeObserver(function () { schedule(); });
    navList().forEach(function (entry) { ro.observe(entry.bar); });
  }
})();
